// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__L020-","noLongPress":"navy-modal_noLongPress__RZ2dJ"};